exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".react-spinner-loader-svg-calLoader{width:230px;height:230px;transform-origin:115px 115px;animation:1.4s linear infinite loader-spin}.react-spinner-loader-svg-cal-loader__path{animation:1.4s ease-in-out infinite loader-path}@keyframes loader-spin{to{transform:rotate(1turn)}}@keyframes loader-path{0%{stroke-dasharray:0,580,0,0,0,0,0,0,0}50%{stroke-dasharray:0,450,10,30,10,30,10,30,10}to{stroke-dasharray:0,580,0,0,0,0,0,0,0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/react-loader-spinner/dist/loader/css/Plane.css
// module id = 679
// module chunks = 0